// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio__option[data-v-691b6507]{padding:.5rem;border-radius:1rem;border:2px solid #c4c4c4}.v-expansion-panel[data-v-691b6507]:before{box-shadow:none!important}", ""]);
// Exports
module.exports = exports;
